import { render, staticRenderFns } from "./ItemKiallitas.vue?vue&type=template&id=7827d34a&scoped=true&"
import script from "./ItemKiallitas.vue?vue&type=script&lang=js&"
export * from "./ItemKiallitas.vue?vue&type=script&lang=js&"
import style0 from "./ItemKiallitas.vue?vue&type=style&index=0&id=7827d34a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827d34a",
  null
  
)

export default component.exports